import { InputGroup, Form } from 'react-bootstrap';
import { IconSearch } from '../atoms/Icon';

function SearchBar({ placeholder = 'Buscar...', value, onChange }) {
  return (
    <InputGroup>
      <InputGroup.Text
        style={{
          backgroundColor: 'var(--color-purple-ghost)',
          border: '1px solid var(--color-purple-mid)',
          color: 'var(--color-purple-primary)',
        }}
      >
        <IconSearch size={16} />
      </InputGroup.Text>
      <Form.Control
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{ borderLeft: 'none', borderColor: 'var(--color-purple-mid)' }}
      />
    </InputGroup>
  );
}

export default SearchBar;
